export default __webpack_public_path__ + "static/card-back-6c0555414ba7bbb5bfb260e3f5045bd7.png";